// extracted by mini-css-extract-plugin
module.exports = {"noData":"NoData_noData__WinN2","icon":"NoData_icon__evWla","description":"NoData_description__ExMQL","absolutePosition":"NoData_absolutePosition__AB9Xs"};